import { createElement } from 'react';
const Text = function Text({ content, style: styleOption = {}, link, }) {
    function linkRouter() {
        if (link) {
            window.open(link, '_blank');
        }
    }
    return (createElement("span", { className: "text-content", onClick: () => linkRouter(), style: { display: 'inline-block', ...styleOption } }, content));
};
export default Text;
